import { Info } from "lucide-react";

const DISCLAIMER =
  "The information provided on this page is for general informational purposes only and does not "
  + "constitute legal advice. Accessing this page or receiving any guidance does not create an "
  + "attorney-client relationship. A formal attorney-client relationship is established only upon "
  + "signing a formal engagement agreement with a lawyer.";

/**
 * LegalDisclaimerBanner — now renders a subtle inline note instead of an amber alert banner.
 * Kept as a component so existing import sites continue to compile without changes.
 */
export default function LegalDisclaimerBanner({ className = "" }) {
  return (
    <div
      className={`w-full border-b ${className}`}
      role="note"
      aria-label="Legal disclaimer"
      data-testid="legal-disclaimer-banner"
    >
      <div className="mx-auto flex w-full max-w-6xl items-start gap-2 px-4 py-2.5 sm:px-6">
        <Info className="mt-0.5 h-3.5 w-3.5 shrink-0 text-muted-foreground/60" aria-hidden />
        <p className="text-[11px] leading-relaxed text-muted-foreground/70">
          <strong className="font-medium">Disclaimer:</strong> {DISCLAIMER}
        </p>
      </div>
    </div>
  );
}
